module.exports = __webpack_public_path__ + "static/img/hybridInverterv6.0146cbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hybridInverterv6.png
// module id = 490
// module chunks = 1